import { useState as o, useEffect as u } from "react";
const h = (e) => {
  const [n, t] = o(!1), [r, c] = o(!1);
  return u(() => {
    const a = new AbortController(), { signal: i } = a, s = window.matchMedia(`(max-width: ${e})`);
    t(s.matches), c(!0);
    const l = (d) => {
      t(d.matches);
    };
    return s.addEventListener("change", l, { signal: i }), () => {
      a.abort();
    };
  }, [e]), { isBelowBreakpoint: n, hasEvaluatedView: r };
};
export {
  h as useMediaWatcher
};
